
import { createApp } from "vue";
import PasswortVergessenForm from "./PasswortVergessenForm.vue";
import ApiService from "@/services/apiService";

let passwortVergessenContainer = document.getElementById("passwort-vergessen");

if(passwortVergessenContainer) {
    const app= createApp(PasswortVergessenForm, { container:passwortVergessenContainer });
    ApiService.create();
    app.mount(passwortVergessenContainer);
}


